import { useQuery } from '@nerdwallet/apollo';
import { ExperimentQuery } from './queries';
/**
 * React hook that returns Experiment test info.
 * Abstraction around useQuery for fetching Experiment test data
 */
var useExperiment = function useExperiment(_ref) {
  var _data$experimentDecis;
  var testName = _ref.testName,
    _ref$userAttributes = _ref.userAttributes,
    userAttributes = _ref$userAttributes === void 0 ? {} : _ref$userAttributes;
  var _useQuery = useQuery(ExperimentQuery, {
      variables: {
        testName: testName,
        userAttributes: userAttributes
      },
      errorPolicy: 'all'
    }),
    loading = _useQuery.loading,
    data = _useQuery.data,
    error = _useQuery.error;
  if (loading) return {
    loading: loading
  };
  if (error) return {
    loading: loading,
    error: error
  };
  var experiment = data === null || data === void 0 ? void 0 : (_data$experimentDecis = data.experimentDecisions) === null || _data$experimentDecis === void 0 ? void 0 : _data$experimentDecis[0];
  var _ref2 = experiment || {},
    experimentName = _ref2.experimentName,
    assignedVariantName = _ref2.assignedVariantName,
    modelExecutionIds = _ref2.modelExecutionIds;
  return {
    loading: loading,
    error: error,
    experimentName: experimentName,
    assignedVariantName: assignedVariantName,
    modelExecutionIds: modelExecutionIds
  };
};
export default useExperiment;